import { Controller } from "@hotwired/stimulus"
import pageMessageBroker from "../page_message_broker"

// Connects to data-controller="plan-design-selection-modal-trigger"
export default class extends Controller {
  static values = {
    currentIds: String,
    clientId: String,
  }

  open() {
    pageMessageBroker.dispatch("open-plan-design-selection-modal", {
      currentIds: this.currentIdsValue,
      clientId: this.clientIdValue,
    })
  }
}
